import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";

import PublicLayout from "@/pages/public/PublicLayout";
import HomePage from "@/pages/public/HomePage";
const ProductsPage = lazy(() => import("@/pages/public/ProductsPage"));
const ProductDetailPage = lazy(() => import("@/pages/public/ProductDetailPage"));
const ContactPage = lazy(() => import("@/pages/public/ContactPage"));

const AdminLogin = lazy(() => import("@/pages/admin/AdminLogin"));
const AdminLayout = lazy(() => import("@/pages/admin/AdminLayout"));
const AdminDashboard = lazy(() => import("@/pages/admin/AdminDashboard"));
const AdminProducts = lazy(() => import("@/pages/admin/AdminProducts"));
const AdminCategories = lazy(() => import("@/pages/admin/AdminCategories"));
const AdminBanners = lazy(() => import("@/pages/admin/AdminBanners"));
const AdminSettings = lazy(() => import("@/pages/admin/AdminSettings"));
const AdminStock = lazy(() => import("@/pages/admin/AdminStock"));
const AdminBranches = lazy(() => import("@/pages/admin/AdminBranches"));
const AdminInvoices = lazy(() => import("@/pages/admin/AdminInvoices"));
import ProtectedRoute from "@/pages/admin/ProtectedRoute";

import { ShopProvider } from "@/context/ShopContext";
const CartPage = lazy(() => import("@/pages/public/CartPage"));
const AccountPage = lazy(() => import("@/pages/public/AccountPage"));
const AdminOrders = lazy(() => import("@/pages/admin/AdminOrders"));
const AdminCustomers = lazy(() => import("@/pages/admin/AdminCustomers"));
const AdminSecurity = lazy(() => import("@/pages/admin/AdminSecurity"));
const AdminTeam = lazy(() => import("@/pages/admin/AdminTeam"));
const AdminReception = lazy(() => import("@/pages/admin/AdminReception"));
const FinancePage = lazy(() => import("@/pages/admin/FinancePage"));
const FinanceAccess = lazy(() => import("@/pages/admin/FinanceAccess"));
const AdminGuide = lazy(() => import("@/pages/admin/AdminGuide"));
function App() {
  return (
    <AuthProvider>
      <SettingsProvider>
        <BrowserRouter><ShopProvider>
          <Toaster richColors position="top-right" />
          <Suspense fallback={<div role="status" aria-live="polite" className="min-h-[40vh] flex items-center justify-center p-6 text-muted-foreground">Carregando esta área…</div>}>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/carrinho" element={<CartPage />} /><Route path="/minha-conta" element={<AccountPage />} /><Route path="/produtos" element={<ProductsPage />} />
              <Route path="/produtos/:id" element={<ProductDetailPage />} />
              <Route path="/categorias" element={<ProductsPage />} />
              <Route path="/novidades" element={<ProductsPage filterNew />} />
              <Route path="/ofertas" element={<ProductsPage />} />
              <Route path="/loja" element={<ContactPage />} />
              <Route path="/contato" element={<ContactPage />} />
            </Route>

            <Route path="/financeiro" element={<FinancePage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route element={<ProtectedRoute />}>
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboard />} /><Route path="pedidos" element={<AdminOrders />} /><Route path="clientes" element={<AdminCustomers />} />
                <Route path="produtos" element={<AdminProducts />} />
                <Route path="categorias" element={<AdminCategories />} />
                <Route path="banners" element={<AdminBanners />} />
                <Route path="estoque" element={<AdminStock />} /><Route path="filiais" element={<AdminBranches />} />
                <Route path="notas" element={<AdminInvoices />} /><Route path="guia" element={<AdminGuide />} /><Route path="recebimento" element={<AdminReception />} /><Route path="publicacao" element={<AdminReception />} /><Route path="equipe" element={<AdminTeam />} /><Route path="acesso-financeiro" element={<FinanceAccess />} />
                <Route path="configuracoes" element={<AdminSettings />} /><Route path="seguranca" element={<AdminSecurity />} />
              </Route>
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          </Suspense>
        </ShopProvider></BrowserRouter>
      </SettingsProvider>
    </AuthProvider>
  );
}

export default App;
